export default {
  ok: {
    en: 'Ok',
  },
  connectWallet: {
    en: 'Sign up / Login',
  },
  changeNetwork: {
    en: 'Change network',
  },
  loading: {
    en: 'Loading',
  },
  approve: {
    en: 'APPROVE',
  },
  close: {
    en: 'Close',
  },
  tryAgain: {
    en: 'Try again',
  },
  placeBet: {
    en: 'PLACE BET',
  },
  okay: {
    en: 'Okay',
  },
  gotIt: {
    en: 'Got it',
  },
  continue: {
    en: 'Continue',
  },
  switch: {
    Optimism: {
      en: 'Optimism',
    },
    Arbitrum: {
      en: 'Arbitrum',
    },
  },
}
